import React, {useContext, useEffect} from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import NextButton from "./NextButton";
import {RouterContext} from "./Onboarding"

export default function Intro1(props) {
  const route = useContext(RouterContext)

  useEffect(() => {
    window.localStorage.setItem(
      "routerHistory",
      JSON.stringify([...route.get])
    );
  }, [route.get]);
  let welcome = require("images/onboarding/dp-welcome.png");
  welcome = <img src={`/datapulse${welcome}`} style={{ maxWidth: "100%" }} />;
  let logo = require("images/onboarding/datapulse.png");
  logo = <img className="pl-3 pb-2" src={`/datapulse${logo}`} />;
  let ipad = require("images/onboarding/dp-ipad.png");
  ipad = <img className="pb-2" src={`/datapulse${ipad}`} />;
  let chat = require("images/onboarding/chaticon.png");
  chat = <img className="pr-3 pt-2" src={`/datapulse${chat}`} />;
  let small = require("images/onboarding/small-circle.png");
  small = <img className="" src={`/datapulse${small}`} />;
  let medium = require("images/onboarding/medium-circle.png");
  medium = <img className="" src={`/datapulse${medium}`} />;
  large;
  let large = require("images/onboarding/large-circle.png");
  large = <img className="" src={`/datapulse${large}`} />;

  return (
    <div className="transparent">
      <div className="large-circle">{large}</div>
      <div className="medium-circle">{medium}</div>
      <div className="small-circle">{small}</div>
      <div className="text-center mb-3">{welcome}</div>
      <Row>
        <Col></Col>
        <Col style={{ marginBottom: "70px" }} className="col-7">
          <p className="nunito-regular primary f16">
            In the last year, our clients saw a 178% increase in PPC Revenue and a 105% increase in SEO revenue. We're very excited to see your growth as well!
            Which brings us to our first order of business...
          </p>
        </Col>
        <Col></Col>
      </Row>
      <div>
        <div className="text-center" style={{ marginBottom: "38px" }}>
          <span className="f24 visby-medium primary">You are currently looking at {logo}</span>
        </div>
      </div>
      <Row className="mb-4 px-2 welcome-blur">
        <Col>
          <p className="nunito-regular f16 primary">
            DataPulse is our proprietary reporting platform where you can see all of your organic traffic projections, keyword rankings, your personal Digital
            Position team, and way, way, more -- all in real time. It will be your way (and our way too) of monitoring your progress and growth.{" "}
            <strong>The first step to beginning your journey with {route.organization.name} will be to complete this onboarding form within DataPulse.</strong>
          </p>
          <br></br>
          <p className="nunito-regular f16 primary">
            We try to make onboarding as simple and straight-forward as possible for you. You can view your progress at the top of the page, and you can save
            and come back at any time. If you don't know the answer to a question, feel free to skip it and continue. However, please circle back to as much as
            you possibly can, as this information is very necessary for us to do our best work for you. Any of these answers and settings can be changed at any
            time in 'Account Configuration' later.
          </p>
        </Col>
        <Col className="pl-2 ">{ipad}</Col>
      </Row>
      <Row className="pt-2">
        <Col md={4} className="text-right">
          {chat}
        </Col>
        <Col md={5}>
          <p className="f14 nunito-regular bold primary mr-5 pr-5">
            This section is to be completed by the client and the team member together. If you have arranged an onboarding meeting or call, you should begin the
            meeting before continuing forward below.
          </p>
        </Col>
      </Row>
      <input hidden name="current_onboarding_page" value={window.location.href} readOnly />
      <Row className="justify-content-center mt-5">
        <Col md={3}>
          
          <NextButton
            validated={true} 
            btnText={`Begin onboarding`}
            nextPage="/datapulse/onboarding/account_configuration_intro"
            invalidText={`We need more information on this page before you continue.`}
            submitForm={props.submitForm}
            className="welcome-btn"
          />
        </Col>
      </Row>
    </div>
  );
}
